import React from 'react'
import { useEffect, useState, useRef } from 'react';
import { Modal, ModalHeader,Media,ModalBody,ModalFooter,Col,Button,Row ,Form,Input,InputGroupAddon,InputGroup,InputGroupText} from 'reactstrap';




export const ModalPrice = (props) => {

    const {titlePrice,typeprice="viewPrices" ,handleprices,togglePrice,modalPrice,calcularPorcentajeDescuento,resul,handleInputChange,porcentaje,arrayExams,llavecard} = props;

   // let price1 = localStorage.getItem('Perfil');

    


  return (

    

    <Modal isOpen={modalPrice} toggle={togglePrice}  backdrop='static' keyboard={false} centered={true} className="modal-xs" >
    <ModalHeader toggle={togglePrice} className="bg-primary">
    {titlePrice}
    </ModalHeader>
        {
             typeprice ==="viewPrices" ?
             <ModalBody>
                <Col sm="12" key={llavecard}>
                    <Row>
                        <Col sm="3">
                        </Col>
                        <Col sm="6">
                        <label htmlFor="">Nuevo Precio:</label> <br /> 
                                <InputGroup className="">
                                <InputGroupAddon addonType="append"><InputGroupText>{"$"}</InputGroupText></InputGroupAddon>

                                <Input className="form-control" name="porcentaje" value={porcentaje} onChange={handleInputChange}  /> 
                                </InputGroup>
                        </Col>
                    </Row>
                </Col>

            




                {/* <Col sm ="12"> <br /> <br />
                <Input className="form-control form-control-sm input-air-primary" name='porcentaje' value={porcentaje}    onChange={handleInputChange} >
                
                </Input>

                </Col> */}
             

             </ModalBody>
             :""
       }       
    <ModalFooter>
        <Button size="sm" className='btn-air-light' outline color='primary' onClick={() => calcularPorcentajeDescuento(arrayExams,porcentaje)}>
            Calcular
        </Button>
    </ModalFooter> 
    
    
</Modal>
    
  )
}
